/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Card } from "@components/anti/Card"
import { Cover } from "@components/anti/Cover"
import Select from "@components/anti/Forms/components/select"
import Link from "@components/anti/Link"
import CardList from "@components/global/CardList"
import { getPostsByType } from "lib/api"
import { linkNewsroom } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { formatDate, imgUrl } from "src/mixins"

function NewsroomPressRelease({ locale, yearList, data }) {
  const router = useRouter()
  const [state, setState] = useState({
    year: { label: yearList[0], value: yearList[0] },
    featured: {},
    list: [],
    pagination: {},
  })
  const { featured, list, pagination } = state
  useEffect(() => {
    if (typeof window !== "undefined" && featured) {
      const text = document.getElementById("text-cover-data")
      if (text) {
        const listP = text?.getElementsByTagName("p")
        listP[0]?.classList.add("text-truncate-twoline")
        const string = listP[0]?.lastChild.textContent
        setState((prev) => ({
          ...prev,
          textFeaturedCover: string,
        }))
      }
    }
  }, [state.featured])
  const listMapping = (listData, paginationData) => {
    let listFeatured = listData?.find((item) => item.featured === "YES")
    let listNotFeatured = []
    if (listFeatured && Object.keys(listFeatured).length) {
      listNotFeatured = listData?.filter((item) => item.featured === "NO")
    } else if (listData?.length > 1) {
      listFeatured = { ...listData[0] }
      listNotFeatured = listData?.filter(
        (item, i) => item.featured === "NO" && i !== 0
      )
    } else {
      listFeatured = null
      listNotFeatured = listData?.filter((item) => item.featured === "NO")
    }
    setState((prev) => ({
      ...prev,
      list: listNotFeatured,
      featured: listFeatured,
      pagination: paginationData,
    }))
  }
  const handleChangeYear = async (year) => {
    setState((prev) => ({ ...prev, year: { value: +year, label: year } }))
    const news = await getPostsByType({
      first: 9,
      page: 1,
      year: +year,
      type: "NEWS",
      orderBy: [
        {
          column: "published_at",
          order: "DESC",
        },
      ],
    })
    listMapping(news?.data, news?.paginatorInfo)
  }
  const onClickLoadMore = async () => {
    try {
      const newsUpdate = await getPostsByType({
        first: 9,
        type: "NEWS",
        year: state.year?.value,
        page: state.pagination.currentPage + 1,
        orderBy: [
          {
            column: "published_at",
            order: "DESC",
          },
        ],
      })
      if (newsUpdate) {
        setState((prev) => ({
          ...prev,
          list: [...state.list, ...newsUpdate.data],
          pagination: newsUpdate.paginatorInfo,
        }))
        return newsUpdate
      }
      return null
    } catch (error) {
      return { notFound: true }
    }
  }
  useEffect(() => {
    listMapping(data?.news?.data, data?.news?.paginatorInfo)
  }, [data])
  useEffect(() => {
    if (router.query?.year) {
      handleChangeYear(router.query?.year)
    }
  }, [router.query])

  return (
    <div className="newsroom-press-release">
      <div className="bg" />
      <div className="container d-none d-md-block">
        <Select
          className="newsroom-press-release__year-select"
          options={yearList?.map((item) => ({
            label: item,
            value: item,
          }))}
          value={state.year}
          onChange={(_, val) => {
            // handleChangeYear(val)
            router.push({ pathname: linkNewsroom, query: { year: +val.value } })
          }}
        />
      </div>
      {featured ? (
        <div className="newsroom-press-release__featured">
          <div
            id="text-cover-data"
            className="d-none"
            dangerouslySetInnerHTML={{ __html: featured[`content_${locale}`] }}
          />
          <Cover
            img={imgUrl(featured?.featured_image)}
            imgMd={imgUrl(featured?.featured_image)}
            title={featured[`title_${locale}`]}
            text={state.textFeaturedCover}
            titleClassName="text-truncate-threeline"
            textClassName="text-truncate-twoline"
            label={formatDate(featured?.published_at)}
            imgOverlay="50"
          >
            <Link
              className="text-white text-capitalize"
              href={`${linkNewsroom}/${featured?.slug}`}
              withArrow
            >
              {translations[`read_more_${locale}`]}
            </Link>
          </Cover>
        </div>
      ) : null}
      <div className="container d-block d-md-none">
        <Select
          className="newsroom-press-release__year-select-mobile pt-3"
          options={yearList?.map((item) => ({
            label: item,
            value: item,
          }))}
          value={state.year}
          onChange={(_, val) => {
            // handleChangeYear(val)
            router.push({ pathname: linkNewsroom, query: { year: +val.value } })
          }}
        />
      </div>
      <CardList
        data={list}
        className="newsroom-press-release__list container py-main"
        keyPrefix="newsroom-press-release__item"
        render={(item, i) => (
          <Card
            title={item[`title_${locale}`]}
            text={formatDate(item?.published_at)}
            tags={
              item?.categories?.length && item?.categories[0][`title_${locale}`]
            }
            img={imgUrl(item?.thumb_image)}
            imgRatio="r-4-3"
            link={`${linkNewsroom}/${item.slug}`}
            withAnim
            index={i}
          />
        )}
        hasMore={pagination?.hasMorePages}
        onClickLoadMore={onClickLoadMore}
      />
    </div>
  )
}

export default NewsroomPressRelease
